module.exports = __webpack_public_path__ + "img/inactive-skill-star.b1c010e4.svg";